export class mapFeatures {
	constructor(map) {
		this.map = map;
		this.H = window.H;
	}

	addMarkerToMap(coordinates, options = {icon, draggable, title: ""}) {
		let _opts = {
			drag: options.draggable,
			icon: options.icon,
			title: options.title,
			onDragend: options.onDragend,
			behavior: options.behavior,
		};
		const coords = {lat: coordinates.cy, lng: coordinates.cx};
		let icon = new this.H.map.Icon(_opts.icon);
		const marker = new this.H.map.Marker(coords, {icon}, {volatility: true});
		marker.draggable = _opts.drag;
		this.map.addObject(marker);
		this.map.setCenter({lat: parseFloat(coordinates.cy), lng: parseFloat(coordinates.cx)});
		this.map.setZoom(14);
		if (_opts.drag === true) this.addDraggableMarker(marker, _opts);
		return marker;
	}

	addDraggableMarker(markerDraggable, _opts) {
		let map = this.map;
		let H = window.H;
		let behavior = _opts.behavior;
		markerDraggable.addEventListener(
			"dragstart",
			function (ev) {
				let target = ev.target,
					pointer = ev.currentPointer;
				if (target instanceof H.map.Marker) {
					let targetPosition = map.geoToScreen(target.getGeometry());
					target["offset"] = new H.math.Point(
						pointer.viewportX - targetPosition.x,
						pointer.viewportY - targetPosition.y
					);
					behavior.disable();
				}
			},
			false
		);
		markerDraggable.addEventListener(
			"dragend",
			function (ev) {
				let target = ev.target;
				if (target instanceof H.map.Marker) {
					behavior.enable();
				}
				let pos = {
					lat: markerDraggable.getGeometry().lat,
					lng: markerDraggable.getGeometry().lng,
				};
				_opts.onDragend(pos);
			},
			false
		);
		markerDraggable.addEventListener(
			"drag",
			function (ev) {
				let target = ev.target,
					pointer = ev.currentPointer;
				if (target instanceof H.map.Marker) {
					target.setGeometry(
						map.screenToGeo(pointer.viewportX - target["offset"].x, pointer.viewportY - target["offset"].y)
					);
				}
			},
			false
		);
		markerDraggable.addEventListener(
			"pointerleave",
			function () {
				map.getViewPort().element.style.cursor = "crosshair";
			},
			true
		);
		markerDraggable.addEventListener(
			"pointerenter",
			function () {
				map.getViewPort().element.style.cursor = "pointer";
			},
			true
		);
	}

	removeMarker(marker) {
		if (marker) {
			this.map.removeObject(marker);
		}
	}
}
